import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    color: "#353535",
    boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
    width: "100%",
    height: "81px",
    padding: "0px 60px",
  },
  leftText: {
    fontSize: "16px",
    letterSpacing: 0,
    width: "335px",
  },
  centerText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#00833E",
    fontSize: "20px",
    width: "249px",
  },
  rightMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FEE8E8",
    color: "#E11919",
    fontFamily: "Lucida Grande",
    letterSpacing: 0,
    fontSize: "15px",
    padding: "8px 16px",
    fontWeight: "bold",
  },
  //------------------------------------------ Mobile --------------------------------------------//
  mobile_container: {
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    color: "#353535",
    boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
    width: "100%",
  },
  mobile_box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "20px 17px",
  },
  mobile_topMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FEE8E8",
    color: "#E11919",
    fontFamily: "Lucida Grande",
    fontSize: "14px",
    padding: "8px 20px",
    marginBottom: "16.6px",
    width: "100%",
  },
  mobile_leftText: {
    fontSize: "18px",
    letterSpacing: 0,
  },
  mobile_centerText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#00833E",
    fontSize: "20px",
    width: "200px",
  },
  normalWight: {
    fontWeight: "lighter",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "17px",
  },
  //----------------------------------------------------------------------------------------------//

  largeFont: {
    fontSize: "35px",
    marginLeft: "8px",
  },
  mobile_largeFont: {
    fontSize: "28px",
    marginLeft: "4px",
  },

  spanWithMarginRight: {
    marginRight: "4px",
    fontWeight: "lighter",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "17px",
  },
}));

export default useStyles;
